import styled from 'styled-components';
import { FaFacebook, FaInstagram, FaWhatsapp } from 'react-icons/fa';

const navLinks = [
  { label: 'Inicio', to: '#hero' },
  { label: 'Nosotros', to: '#about' },
  { label: 'Productos', to: '#products' },
  { label: 'Clientes', to: '#clients' },
  { label: 'Contacto', to: '#contact' },
];

export default function Footer() {
  const scrollTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <FooterEl>
      <Inner>
        <Top>
          <Brand>
            <Logo><img src="/img/logo/grupojaycom_logo.png" alt="Grupo Jaycom Tarimas" /></Logo>
            <Tagline>Fabricación de tarimas con calidad e higiene industrial.</Tagline>
            <Socials>
              <SocialLink href="https://facebook.com" target="_blank" rel="noopener" aria-label="Facebook">
                <FaFacebook size={18} />
              </SocialLink>
              <SocialLink href="https://instagram.com" target="_blank" rel="noopener" aria-label="Instagram">
                <FaInstagram size={18} />
              </SocialLink>
              <SocialLink href="https://wa.me/524311011283?text=Hola%2C%20los%20contacto%20desde%20su%20sitio%20web." target="_blank" rel="noopener" aria-label="WhatsApp">
                <FaWhatsapp size={18} />
              </SocialLink>
            </Socials>
          </Brand>

          <Nav>
            <NavTitle>Navegación</NavTitle>
            {navLinks.map((l) => (
              <NavLink key={l.label} onClick={() => scrollTo(l.to)}>{l.label}</NavLink>
            ))}
          </Nav>

          <Nav>
            <NavTitle>Productos</NavTitle>
            <NavLink as="span">Tarimas nuevas</NavLink>
            <NavLink as="span">Tarimas recicladas</NavLink>
            <NavLink as="span">Tarimas mixtas</NavLink>
            <NavLink as="span">Tarimas a medida</NavLink>
          </Nav>

          <Nav>
            <NavTitle>Contacto</NavTitle>
            <NavLink as="a" href="mailto:jaoropezar@hotmail.com">jaoropezar@hotmail.com</NavLink>
            <NavLink as="a" href="https://wa.me/524311011283?text=Hola%2C%20los%20contacto%20desde%20su%20sitio%20web." target="_blank" rel="noopener">WhatsApp ventas</NavLink>
            <NavLink as="span">Matriz — Edo. de México</NavLink>
            <NavLink as="span">Producción — Jalostotitlán, Jal.</NavLink>
          </Nav>
        </Top>

        <Bottom>
          <p>© {new Date().getFullYear()} Grupo Jaycom. Todos los derechos reservados.</p>
          <Legal>
            <a href="#">Política de privacidad</a>
            <span>·</span>
            <a href="#">Términos y condiciones</a>
          </Legal>
        </Bottom>
      </Inner>
    </FooterEl>
  );
}

const FooterEl = styled.footer`
  background: #1A1A1A;
  border-top: 3px solid var(--blue);
  padding: 5rem 2rem 2rem;
`;

const Inner = styled.div`
  max-width: 1280px;
  margin: 0 auto;
`;

const Top = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 3rem;
  margin-bottom: 4rem;
  @media (max-width: 900px) { grid-template-columns: 1fr 1fr; gap: 2rem; }
  @media (max-width: 480px) { grid-template-columns: 1fr; }
`;

const Brand = styled.div``;

const Logo = styled.p`
  margin-bottom: 0.75rem;

  img {
    height: 100px;
    width: auto;
    display: block;
    filter: brightness(0) invert(1);
  }
`;

const Tagline = styled.p`
  font-size: 0.85rem;
  line-height: 1.6;
  color: rgba(255,255,255,0.5);
  max-width: 260px;
  margin-bottom: 1.5rem;
`;

const Socials = styled.div`
  display: flex;
  gap: 0.75rem;
`;

const SocialLink = styled.a`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: rgba(255,255,255,0.08);
  border: 1px solid rgba(255,255,255,0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255,255,255,0.6);
  transition: color 0.2s, border-color 0.2s, background 0.2s;
  &:hover {
    color: #fff;
    border-color: rgba(208,2,27,0.5);
    background: rgba(208,2,27,0.15);
  }
`;

const Nav = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
`;

const NavTitle = styled.p`
  font-size: 0.7rem;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--red);
  text-shadow: var(--shadow-3d);
  margin-bottom: 0.5rem;
`;

const NavLink = styled.button`
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  font-size: 0.85rem;
  color: rgba(255,255,255,0.45);
  font-family: 'Inter', sans-serif;
  transition: color 0.2s;
  padding: 0;
  &:hover { color: var(--white); }
`;

const Bottom = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding-top: 2rem;
  border-top: 1px solid rgba(255,255,255,0.06);
  p { font-size: 0.78rem; color: rgba(255,255,255,0.25); }
`;

const Legal = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.78rem;
  color: rgba(255,255,255,0.25);
  a { transition: color 0.2s; &:hover { color: var(--accent); } }
`;
